import { PhoneNumberInput, type PhoneNumberInputProps } from "@butter/ui";
import { useRootCountryCode, useRootLocale } from "~/root";
import { getRegionalCopy } from "~/utils/localization";

type Props = Pick<
  PhoneNumberInputProps,
  | "value"
  | "onChange"
  | "error"
  | "disabled"
  | "savedInput"
  | "savedCountry"
  | "onInputChange"
>;

export function CheckoutPhoneNumberField(props: Props) {
  const locale = useRootLocale();
  const country = useRootCountryCode();
  return (
    <PhoneNumberInput
      {...props}
      defaultCountry={country}
      locale={locale}
      label={getRegionalCopy(locale).phoneNumber}
      hideLabel
    />
  );
}
